"use client";

import { c as _c } from "react/compiler-runtime";
import { MicOff } from "lucide-react";
import { cn } from "@/lib/utils";
import type { RosterFace } from "../model/meeting-roster";

/** Big participant tile for the full-screen stage. */
export function StageTile(t0) {
  const $ = _c(19);
  const {
    face
  } = t0;
  const speaking = face.speaking && !face.muted;
  let t1;
  if ($[0] !== speaking) {
    t1 = speaking ? <span aria-hidden={true} className="absolute inset-0 animate-ping rounded-full bg-[#5651ff]/25 motion-reduce:animate-none" /> : null;
    $[0] = speaking;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = speaking ? "bg-[#5651ff]/20 text-white shadow-[0_0_0_3px_rgba(86,81,255,0.8),0_4px_24px_rgba(86,81,255,0.45)]" : "bg-white/8 text-white/80";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("relative flex h-24 w-24 items-center justify-center rounded-full text-2xl font-semibold transition-all sm:h-28 sm:w-28", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== face.monogram || $[5] !== speaking || $[6] !== t3) {
    t4 = <span data-speaking={speaking} className={t3}>{face.monogram}</span>;
    $[4] = face.monogram;
    $[5] = speaking;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== face.muted) {
    t5 = face.muted ? <span aria-label="Muted" className="absolute -bottom-1 -right-1 flex h-7 w-7 items-center justify-center rounded-full bg-[#1a2036] text-white/80 ring-2 ring-[#0b1020]"><MicOff className="h-3.5 w-3.5" aria-hidden={true} /></span> : null;
    $[8] = face.muted;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t4 || $[12] !== t5) {
    t6 = <span className="relative flex h-24 w-24 items-center justify-center sm:h-28 sm:w-28">{t1}{t4}{t5}</span>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== face.name) {
    t7 = <span className="max-w-full truncate text-sm font-medium text-white/90" title={face.name}>{face.name}</span>;
    $[14] = face.name;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="flex w-28 flex-col items-center gap-2 sm:w-32">{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}